export default __webpack_public_path__ + "static/media/letter.fd08512e.svg";